import {config} from "../config";
import {ENV} from "../../constant/ENV";

export let apiPublicServerConfig;
export let apiPublicClientConfig;

if (config.env === ENV.PRODUCTION) {
    apiPublicServerConfig = {
        domain: 'jobstream.fr',
        port: 443,
        protocol: 'https',
        scope: 'site-vitrine',
    }
    apiPublicClientConfig = {
        domain: 'jobstream.fr',
        port: 443,
        protocol: 'https',
        scope: 'site-vitrine',
    }
} else {
    apiPublicServerConfig = {
        domain: 'localhost',
        port: 5000,
        protocol: 'http',
        scope: 'site-vitrine',
    }
    apiPublicClientConfig = {
        domain: 'localhost',
        port: 8080,
        protocol: 'http',
        scope: 'site-vitrine',
    }
}